import React from "react";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import "./CSS/Courspage.css";
import pdf1 from "./Images/JanusreeCourse.pdf";
import image1 from "./Images/CourseJVS.jpg";
import Loader from "./Components/Loader";

const CoursePage = () => {
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = pdf1; 
    link.download = "CourseDetails.pdf";
    document.body.appendChild(link); 
    link.click(); 
    document.body.removeChild(link); 
  };

  return (
    <>
      <Header />
      <div className="training-section">
        <div className="training-section__row">
          <div className="glass-card">
            <h2>Who Is This Training For?</h2>
            <ul>
              <li>Aspiring beauty professionals looking to kickstart their careers.</li>
              <li>Individuals passionate about the beauty industry who want to refine their skills.</li>
              <li>Salon owners and employees seeking to upgrade their expertise.</li>
              <li>Anyone interested in learning advanced beauty techniques for personal or professional use.</li>
            </ul>
          </div>
          <div className="training-section__image">
            <img src={image1} alt="Beauty Training" />
          </div>
        </div>

        <div className="training-section__row">
          <div className="glass-card">
            <h2>What Is Covered in the Training?</h2>
            <ul>
              <li>In-depth knowledge of essential beauty techniques.</li>
              <li>Hands-on experience with professional tools and products.</li>
              <li>Advanced insights into the latest trends in the beauty industry.</li>
              <li>Guidance on establishing and growing a beauty business.</li>
            </ul>
          </div>
          <div className="glass-card">
            <h2>Key Topics</h2>
            <ul>
              <li>Skincare Basics: Understanding skin types, facial treatments, and skincare routines.</li>
              <li>Makeup Artistry: Techniques for day and evening makeup, bridal looks, and high-definition makeup.</li>
              <li>Hair Styling: Basic and advanced hairstyling techniques, including braiding, curling, and updos.</li>
              <li>Manicure and Pedicure: Nail care essentials, nail art, and gel polish application.</li>
              <li>Waxing and Threading: Techniques for hair removal and shaping.</li>
              <li>Business and Marketing Skills: Tips for starting your beauty business, client management, and effective marketing strategies.</li>
            </ul>
          </div>
        </div>

        <div className="download-section">
          <button className="download-button bg-primary" onClick={handleDownload}>
            Download Course
          </button>
        </div>
      </div>
      <Loader/>
      <Footer />
    </>
  );
};

export default CoursePage;
